import { useReveal } from "@/lib/useReveal";

const VALUES = [
    {
        n: "01",
        title: "Půda",
        body: "Nechory mají převážně sprašové černozemě s obsahem vápna, které révě poskytují ideální podmínky pro růst. Místní teplé klima dává vínům plnost, ovocnost a příjemnou mineralitu.",
    },
    {
        n: "02",
        title: "Ruční práce",
        body: "Sklízíme ručně a hrozny pečlivě třídíme už přímo na vinici. Do sklepa tak putují pouze ty nejlepší hrozny, které jsou základem našich vín.",
    },
    {
        n: "03",
        title: "Čas",
        body: "Ve sklepe necháváme víno zrát, pravidelně ho kontrolujeme a zasahujeme jen tehdy, když je to potřeba. Každá odrůda má svůj vlastní čas a právě ten respektujeme.",
    },
];

export default function Values() {
    const { ref, visible } = useReveal();
    return (
        <section
            ref={ref}
            data-testid="values-section"
            className={`py-20 md:py-28 px-6 md:px-12 bg-cream border-y border-ink/10 transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
        >
            <div className="mx-auto max-w-[1500px]">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
                    {VALUES.map((v) => (
                        <div key={v.n} data-testid={`value-${v.n}`} className="group">
                            <div className="font-serif text-5xl md:text-6xl text-burgundy/30 mb-4 transition-colors duration-500 group-hover:text-burgundy">
                                {v.n}
                            </div>
                            <div className="editorial-line mb-5"></div>
                            <h3 className="font-serif text-3xl md:text-4xl text-ink mb-3 leading-tight">{v.title}</h3>
                            <p className="text-sm md:text-base text-ink2 leading-relaxed">{v.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
